export enum CloudflareAccountsQueryKeys {
  GetAll = 'accountsCloudflare/getAll',
  GetOneById = 'accountsCloudflare/getOneById',
  Create = 'accountsCloudflare/create',
  Edit = 'accountsCloudflare/edit',
  Autocomplete = 'accountsCloudflare/autocomplete',
  Breadcrumb = 'accountsCloudflare/breadcrumb'
}
